// Every connection read is keyed by the customer it belongs to. The customer is the one this tab
// shows (useAppStore), passed in rather than read from IndexedDB, which every tab shares: another
// tab picking a different customer must not change what this tab reads, reloads or deletes.
//
// Each key starts with its kind and then the customer, so leaving the connection out gives a key
// that matches all of that customer's reads of that kind.
const perConnection =
  (kind: string) =>
  (userId: string, connectionId?: string): string[] =>
    connectionId ? [kind, userId, connectionId] : [kind, userId]

export const connectionQueryKeys = {
  list: (userId: string) => ['connections', userId],
  detail: perConnection('connection-detail'),
  accounts: perConnection('financial-accounts'),
  syncHistory: perConnection('sync-history'),
  // Built by the Transactions page from the same connections and accounts.
  transactionFilters: (userId: string) => ['transaction-filter-directory', userId],
}
